"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.025 4.01a1.526 1.526 0 0 1 1.95 0l1.434 1.192c.733.61.733 1.736 0 2.346L10.975 8.74c-.565.47-1.385.47-1.95 0L7.59 7.548a1.526 1.526 0 0 1 0-2.346zM4.483 7.635a1.526 1.526 0 0 1 1.951 0l1.434 1.192c.733.61.733 1.736 0 2.346l-1.434 1.192c-.565.47-1.385.47-1.95 0L3.05 11.173a1.526 1.526 0 0 1 0-2.346zm9.083 0a1.526 1.526 0 0 1 1.95 0l1.434 1.192c.733.61.733 1.736 0 2.346l-1.433 1.192c-.566.47-1.386.47-1.951 0l-1.434-1.192a1.526 1.526 0 0 1 0-2.346zM9.025 11.26a1.526 1.526 0 0 1 1.95 0l1.434 1.192c.733.61.733 1.736 0 2.346l-1.434 1.192c-.565.47-1.385.47-1.95 0L7.59 14.798a1.526 1.526 0 0 1 0-2.346z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WorkAppFillIcon20.js.map